import { BarChartSeries, BarChartType } from "@mantine/charts";
import { BAR_CHART_RADIUS } from "./bar-chart.constants";

/**
 * Returns the radius for the bar chart based on the series item, series, and type.
 * @param seriesItem The current series item.
 * @param series The array of all series items.
 * @param type The type of bar chart (e.g., stacked, percent, waterfall, default).
 * @returns The radius or an array of radii for the corners of the bar.
 */
export const getBarPropsRadius = (
    seriesItem: BarChartSeries,
    series: BarChartSeries[],
    type: BarChartType
): number | [number, number, number, number] => {
    const isFirstItem = series.indexOf(seriesItem) === 0;
    const isLastItem = series.indexOf(seriesItem) === series.length - 1;

    switch (type) {
        case "stacked":
        case "percent":
            if (isFirstItem) {
                return [0, 0, BAR_CHART_RADIUS, BAR_CHART_RADIUS];
            }

            if (isLastItem) {
                return [BAR_CHART_RADIUS, BAR_CHART_RADIUS, 0, 0];
            }

            return 0;
        case "waterfall":
        case "default":
            return BAR_CHART_RADIUS;
    }
};
